import React from 'react';

type TabType = 'invoices' | 'customer_insight' | 'payment_reliability_score' | 'financial_risk_score' | 'recommended_actions';

interface CustomerTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  hasInvoices: boolean;
  hasCustomerInsight: boolean;
  hasPaymentReliability: boolean;
  hasFinancialRisk: boolean;
  hasRecommendations: boolean;
}

const CustomerTabs: React.FC<CustomerTabsProps> = ({ 
  activeTab, 
  onTabChange, 
  hasInvoices,
  hasCustomerInsight,
  hasPaymentReliability,
  hasFinancialRisk,
  hasRecommendations
}) => {
  const tabs: { key: TabType; label: string; hasData: boolean }[] = [
    { key: 'invoices', label: 'Invoices', hasData: hasInvoices },
    { key: 'customer_insight', label: 'Customer Insights', hasData: hasCustomerInsight },
    { key: 'payment_reliability_score', label: 'Payment Risk', hasData: hasPaymentReliability },
    { key: 'financial_risk_score', label: 'Finance Risk', hasData: hasFinancialRisk },
    { key: 'recommended_actions', label: 'Recommendations', hasData: hasRecommendations }
  ];

  return (
    <div className="bg-white border-b border-gray-200">
      <nav className="flex space-x-8 px-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.key
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } ${!tab.hasData ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={!tab.hasData}
          >
            {tab.label}
            {!tab.hasData && (
              <span className="ml-1 text-xs">(No data)</span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default CustomerTabs;
